import React from 'react';
import { FallbackProps } from 'react-error-boundary';
import { BasicErrorOrNotFoundPage } from './ErrorOrNotFoundPage';

export const ErrorPage: React.FC<FallbackProps> = ({ resetErrorBoundary }) => {
    return <BasicErrorOrNotFoundPage reset={resetErrorBoundary} />;
};
